import type { FunctionComponent } from "react";
import { TextField } from "../../form/TextField";
import { useStaticDataAtomValue } from "../../staticDataAtom";

export const StreetAddressInput: FunctionComponent = () => {
    const {
        cmsData: {
            location: { streetAddress, pleaseEnterStreetAddress },
        },
    } = useStaticDataAtomValue();

    return (
        <TextField
            label={streetAddress}
            field="streetAddress"
            rules={{
                required: pleaseEnterStreetAddress,
            }}
            dataElementName="street-address"
        />
    );
};
